import { Tabs } from "expo-router";
import React from "react";

import OnboardingProvider from "@/utils/onboarding/OnboardingProvider";

import "reflect-metadata";

export default function RoutesDefaultLayout() {
  return (
    <>
      <OnboardingProvider />
      <Tabs screenOptions={{ headerShown: false }}>
        <Tabs.Screen
          name="index"
          options={{
            tabBarStyle: { display: "none" },
            title: "Home",
            href: null,
          }}
        />
        <Tabs.Screen
          name="signup"
          options={{
            tabBarStyle: { display: "none" },
            title: "Sign Up",
            href: null,
          }}
        />
        <Tabs.Screen
          name="welcome"
          options={{
            tabBarStyle: { display: "none" },
            title: "Welcome",
            href: null,
          }}
        />
        <Tabs.Screen
          name="getready"
          options={{
            tabBarStyle: { display: "none" },
            title: "Get Ready",
            href: null,
          }}
        />
        <Tabs.Screen
          name="finish"
          options={{
            tabBarStyle: { display: "none" },
            title: "Application Finished",
            href: null,
          }}
        />
        <Tabs.Screen
          name="approved"
          options={{
            tabBarStyle: { display: "none" },
            title: "Application Approved",
            href: null,
          }}
        />
        <Tabs.Screen
          name="rejected"
          options={{
            tabBarStyle: { display: "none" },
            title: "Application Rejected",
            href: null,
          }}
        />
        <Tabs.Screen
          name="review"
          options={{
            tabBarStyle: { display: "none" },
            title: "Review Page",
            href: null,
          }}
        />
        <Tabs.Screen
          name="kyc"
          options={{
            tabBarStyle: { display: "none" },
            title: "KYC Corporation Page",
            href: null,
          }}
        />
        <Tabs.Screen
          name="investmentprofile"
          options={{
            tabBarStyle: { display: "none" },
            title: "Investment Profile Corporation Page",
            href: null,
          }}
        />
        <Tabs.Screen
          name="documents"
          options={{
            tabBarStyle: { display: "none" },
            title: "Error Screen",
            href: null,
          }}
        />
        <Tabs.Screen
          name="validate"
          options={{
            tabBarStyle: { display: "none" },
            title: "Validate Sign Up Screen",
            href: null,
          }}
        />
        <Tabs.Screen
          name="passwordrecovery"
          options={{
            tabBarStyle: { display: "none" },
            title: "Password Recovery Screen",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/information"
          options={{
            tabBarStyle: { display: "none" },
            title: "Company Information - Step 1",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/contact"
          options={{
            tabBarStyle: { display: "none" },
            title: "Company Information - Step 2",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/description"
          options={{
            tabBarStyle: { display: "none" },
            title: "Company Description",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/localization"
          options={{
            tabBarStyle: { display: "none" },
            title: "Company Localization",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/registeredaddress"
          options={{
            tabBarStyle: { display: "none" },
            title: "Registered Address",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/physicaladdress"
          options={{
            tabBarStyle: { display: "none" },
            title: "Physical Address",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/addindividual"
          options={{
            tabBarStyle: { display: "none" },
            title: "Add Individual",
            href: null,
          }}
        />
        <Tabs.Screen
          name="corporation/termsandconditions"
          options={{
            tabBarStyle: { display: "none" },
            title: "Corporate Terms and Conditions",
            href: null,
          }}
        />
        <Tabs.Screen
          name="individual/name"
          options={{
            tabBarStyle: { display: "none" },
            title: "Personal Information - Step 1",
            href: null,
          }}
        />
        <Tabs.Screen
          name="individual/information"
          options={{
            tabBarStyle: { display: "none" },
            title: "Personal Information - Step 2",
            href: null,
          }}
        />
        <Tabs.Screen
          name="individual/nationality"
          options={{
            tabBarStyle: { display: "none" },
            title: "Nationality and Passport",
            href: null,
          }}
        />
        <Tabs.Screen
          name="individual/address"
          options={{
            tabBarStyle: { display: "none" },
            title: "Mailing Address",
            href: null,
          }}
        />
        <Tabs.Screen
          name="individual/termsandconditions"
          options={{
            tabBarStyle: { display: "none" },
            title: "Terms and Conditions",
            href: null,
          }}
        />
        <Tabs.Screen
          name="individual/employment"
          options={{
            tabBarStyle: { display: "none" },
            title: "Employment and Occupation",
            href: null,
          }}
        />
      </Tabs>
    </>
  );
}
